// validation schema to be used with Formik for AddEnquiry component
import * as Yup from "yup";
import dayjs from "dayjs";

export const validationSchemaAdd = Yup.object().shape({
  customerResponse: Yup.string().required("Customer response is required"),
  callStatus: Yup.string().required("Call status is required"),
  carCompany: Yup.string().required("Car company is required"),
  carName: Yup.string().required("Car name is required"),
  customerName: Yup.string().required("Customer name is required"),
  customerEmail: Yup.string()
    .email("Invalid email address")
    .required("Customer email is required"),
  customerNumber: Yup.string().required("Customer number is required"),
  customerCity: Yup.string().required("Customer city is required"),
  nextFollowUpDate: Yup.mixed()
    .test(
      "greaterThanOrEqual",
      "DateTime must be greater than or equal to current DateTime",
      (value) => {
        if (value === null) {
          return false;
        }

        return dayjs(value).isAfter(dayjs());
      }
    )
    .required("Next follow up date is required"),
});

export const validationSchemaUpdate = Yup.object().shape({
  customerResponse: Yup.string().required("Customer response is required"),
  callStatus: Yup.string().required("Call status is required"),
  nextFollowUpDate: Yup.mixed()
    .test(
      "greaterThanOrEqual",
      "DateTime must be greater than or equal to current DateTime",
      (value) => {
        if (value === null) {
          return false;
        }

        return dayjs(value).isAfter(dayjs());
      }
    )
    .required("Next follow up date is required"),
});
